import { render, staticRenderFns } from "./EditModel2dTable.vue?vue&type=template&id=3469dc1e&scoped=true"
import script from "./EditModel2dTable.ts?vue&type=script&lang=ts&external"
export * from "./EditModel2dTable.ts?vue&type=script&lang=ts&external"
import style0 from "./EditModel2dTable.vue?vue&type=style&index=0&id=3469dc1e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3469dc1e",
  null
  
)

export default component.exports